import styled from "styled-components";
import { QUERIES } from "../../constants";

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: var(--color-primary);
    padding-right: 163px;
    margin-top: 10px;
    margin-bottom: 10px;

    @media ${QUERIES.phoneAndSmaller}{
        display: none;
    }
`;

export default Divider;